import { useQuery } from '@tanstack/react-query';

import { RiskAssessmentsApi } from 'api/RiskAssessmentsApi';
import { ACCOUNT_RISK_PROFILE_KEY } from 'hooks/keys';
import { useUser } from 'hooks/queries';

export function useAccountRiskProfile(dispensaryId?: string) {
  const riskAssessmentsApi = new RiskAssessmentsApi();
  const { userBankId } = useUser();

  const {
    data: accountRiskProfile,
    isLoading: isLoadingAccountRiskProfile,
    isError: isErrorAccountRiskProfile
  } = useQuery({
    enabled: !!userBankId.length && !!dispensaryId,
    queryKey: [ACCOUNT_RISK_PROFILE_KEY, userBankId, dispensaryId],
    queryFn: () => riskAssessmentsApi.getAccountRiskProfile(userBankId, dispensaryId as string),
    meta: {
      snackbarErrorMessage:
        'There was an issue loading the risk profile. Please try again, or contact support if the problem persists.'
    }
  });

  return { accountRiskProfile, isLoadingAccountRiskProfile, isErrorAccountRiskProfile };
}
